import {
  EcommerceTagCreate,
  EcommerceTagEdit,
  EcommerceTagList
} from 'pages/ecommerce/tags';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'tags',
  label: 'Tags',
  list: EcommerceTagList,
  create: EcommerceTagCreate,
  edit: EcommerceTagEdit,
  actions: ['list', 'show', 'create', 'edit', 'delete'],
  parentName: 'ecommerce'
};

export default generateResources(resource);
